import { render, staticRenderFns } from "./futreport.vue?vue&type=template&id=450edf1c&scoped=true&"
import script from "./futreport.vue?vue&type=script&lang=js&"
export * from "./futreport.vue?vue&type=script&lang=js&"
import style1 from "./futreport.vue?vue&type=style&index=1&id=450edf1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450edf1c",
  null
  
)

export default component.exports